import {createReducer, on} from '@ngrx/store';
import {newsStateInitial} from './news.state.initial';
import {NewsActions} from './news.actions';


export const newsReducer = createReducer(
  newsStateInitial,

  on(
    NewsActions.readNews,
    (state) => ({
      ...state,
      loading: true,
      error: undefined,
    }),
  ),

  on(
    NewsActions.readNewsSuccess,
    (state, {newsDtos, totalElements}) => ({
      ...state,
      newsIds: newsDtos.filter(newsDto => !!newsDto.id).map(newsDto => newsDto.id!),
      totalElements: totalElements,
      loaded: true,
      loading: false,
      error: undefined,
    }),
  ),

  on(
    NewsActions.readNewsFailure,
    (state, {error}) => ({
      ...state,
      loading: false,
      loaded: false,
      error,
    }),
  ),

  on(
    NewsActions.changePageable,
    (state, {pageableDto}) => ({
      ...state,
      pageableDto,
    }),
  ),

);
